import React from "react";
import useEnterProjectPageTutorial from "features/onboarding/hooks/useEnterProjectsPageTutorial";
import styled from "styled-components";
import PlusIcon from "components/Elements/Icons/PlusIcon";

const StyledButton = styled.button`
  margin-bottom: 0;
  flex: 0 0 154px;
  width: 154px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-nav-blue);
  gap: 10px;
  height: 40px;

  &:hover {
    cursor: pointer;
  }
`;

const TextContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;

  p {
    text-transform: capitalize;
    color: var(--color-white);
    font-weight: 500;
    font-size: 15px;
    text-align: center;
    line-height: 15px;
  }
`;

/**
 * This component renders a box that users
 * can click on to navigate to the create post
 * page
 * @returns
 */

export default function CreateProjectButton({ id }: { id?: string }) {
  const { HandleNavigate } = useEnterProjectPageTutorial();
  return (
    <StyledButton
      type="button"
      id={id}
      onClick={() => {
        HandleNavigate();
      }}
    >
      <TextContainer>
        <PlusIcon color="#fff" size={16} />
        <p>Create Project</p>
      </TextContainer>
    </StyledButton>
  );
}

CreateProjectButton.defaultProps = {
  id: null,
};
